import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Rewrite an /api/* path into a fully qualified backend URL. Non-/api URLs are
// passed through untouched.
export const resolveImg = (url) => (url && url.startsWith("/api/") ? `${BACKEND}${url}` : url);

// Slots that render inside a <video> element rather than an <img>. If a Drive
// image-thumbnail URL is ever stored here (older admin saves did this), we
// rewrite it to the direct-media form so the browser can actually stream it.
const VIDEO_KEYS = new Set(["hero_video"]);

const rewriteForVideoSlot = (url) => {
  if (!url) return url;
  const m = url.match(/lh3\.googleusercontent\.com\/d\/([\w-]+)/);
  if (m) return `https://drive.google.com/uc?export=download&id=${m[1]}`;
  return url;
};

const FALLBACKS = {
  hero_poster: "https://images.unsplash.com/photo-1556010656-e60700d4c0d5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  hero_video: "https://videos.pexels.com/video-files/3571264/3571264-hd_1920_1080_30fps.mp4",
  product_alkaline: "https://static.prod-images.emergentagent.com/jobs/8aeb4081-69ac-4743-a2a7-a93fa930bebf/images/25aba44a2db6e74c2ab8e79f616bf919205602691e7651d393a42b37e8b97e51.png",
  product_balanced: "https://static.prod-images.emergentagent.com/jobs/8aeb4081-69ac-4743-a2a7-a93fa930bebf/images/4557726f183939ad1365b174359b95b495cb091be09c8ad04271ec4c45462f89.png",
  product_sparkling: "https://images.unsplash.com/photo-1523362628745-0c100150b504?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  sustainability: "https://static.prod-images.emergentagent.com/jobs/8aeb4081-69ac-4743-a2a7-a93fa930bebf/images/4085e44b9675eb27297fd69aa732f4b53ef700339efc388411b6cfd074cb5f97.png",
  vision_kingfisher: "https://images.unsplash.com/photo-1444464666168-49d633b86797?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

let cache = null;

export const useSiteImages = () => {
  const [images, setImages] = useState(cache || FALLBACKS);

  useEffect(() => {
    if (cache) return;
    axios
      .get(`${BACKEND}/api/site-images`)
      .then((r) => {
        const map = { ...FALLBACKS };
        Object.entries(r.data).forEach(([k, v]) => {
          if (!v.url) return;
          let resolved = resolveImg(v.url);
          if (VIDEO_KEYS.has(k)) resolved = rewriteForVideoSlot(resolved);
          map[k] = resolved;
        });
        cache = map;
        setImages(map);
      })
      .catch(() => {});
  }, []);

  return images;
};
